module.exports = __webpack_public_path__ + "img/icon_centralizacao_de_comunicacoes_hover.ffecb206.png";